import React, { useState, useEffect, useRef } from "react";
import ChatbotScreen from "./ChatbotScreen";
import ChatbotScreenLaVitre from "./ChatbotScreenLaVitre";
import VeilleManager from "../Veille/VeilleManager";
import { useSettingsState, useVeille } from "../../redux/Hooks";



const DisplayManager = () => {
  const veille = useVeille();
  const settingsOpened = useSettingsState();
  const [isVeille, setIsVeille] = useState<boolean>(false);
  const timerRef: React.MutableRefObject<any> = useRef(null);

  useEffect(() => {
    handleTimerRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [veille]);

  useEffect(() => {
    isVeille && timerRef && clearTimeout(timerRef.current);
    !isVeille && handleTimerRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVeille]);

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  const handleTimerRefresh = () => {
    timerRef && clearTimeout(timerRef.current);
    if (veille && veille?.activated && !isVeille) {
      timerRef.current = setTimeout(
        () => {
          console.log("Timer refreshed");
          setIsVeille(true);
          // Minimum 10 seconds
        },
        veille?.timer && veille?.timer >= 10 ? veille?.timer * 1000 : 180000
      );
    }
  };

  const handleTimerRefreshFromClick = () => {
    setIsVeille(false);
  };

  return veille && veille?.activated && isVeille && !settingsOpened ? (
    <VeilleManager timerRefresh={handleTimerRefreshFromClick} />
  ) : (
    <ChatbotScreen timerRefresh={handleTimerRefresh} />
  );
};

export default DisplayManager;
